import operations from '~/helpers/device-operations';
import { Camera } from './camera.model';

export class NOP extends Camera {
    get deviceOperations() {
        return super.deviceOperations.concat([
            operations.installQRCode({ callback: this.installQRCode }),
            operations.resetQRCode({ callback: this.resetQRCode }),
            operations.homekitReset({ callback: this.homekitReset, disabled: this.isHomekitResetDisabled }),
            operations.associateUser({ disabled: this.associateUserDisabled }),
        ]);
    }
}
